import i18n from '../../locales/index'
import restful from '../vuex'
import { Message } from 'view-design'
import axios from '@/libs/axios_ai';

const state = {
  ...restful.states('ai_image'),
  query: { page: 1, limit: 10 },
}
const getters = {
  ...restful.getters('ai_image')
}
const actions = {
  async index ({ commit }, params) {
    const { query } = this.state.ai_image
    query.store_id = localStorage.getItem('SHOPID')
    const path = '/getImgInfoByPage'
    const final_params = Object.assign(query, params)
    const response = await axios.get(path, { params: final_params })
    commit('setRecords', response.data)
    if (response.count) {
      commit('setMeta', {
        total: response.count,
        current: query.page,
        pageSize: query.limit
      })
    }
    commit('loading', false)
  },
  async show ({ commit, state }, id) {
    const { ai_images } = state
    commit('setRecord', ai_images.find(item => item.id === id))
  },
  async update ({ commit }, params) {
    const { _mute_ = false, ...others } = params;
    const body = new FormData()
    for (const key in others) {
      body.append(key, others[key]);
    }
    await axios.post(`/updateItem`, body)
    commit('updateRecordInRecords', others)
    if (!_mute_) {
      Message.success(i18n.t('store_modules_ai_1312'))
    }
  },
  async destroy ({ commit }, id) {
    const body = new FormData()
    body.append('id', id);
    await axios.post('/deleteImgByid', body)
    commit('removeRecordInRecords', id)
    Message.success(i18n.t('store_modules_ai_1313'))
  },
  async clear ({ commit }) {
    commit('clearRecord')
  }

}
const mutations = {
  ...restful.mutations('ai_image'),
  resetQuery: (state) => {
    state.query = { page: 1, limit: 10 }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
